import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../common/config";

export const flopResultService = createApi({
  reducerPath: "flopResult",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api",
  }),
  endpoints: (builder) => ({
    getFlopResult: builder.mutation({
      query: (formdata) => ({
        url: `/users/getalgogroup`,
        method: "POST",
        body: formdata,
      }),
    }),
  }),
});
export const { useGetFlopResultMutation } = flopResultService;
